import { Camera } from "lucide-react";
import { track } from "@/lib/analytics";

export default function Nav({ onCtaClick }) {
  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-md bg-background/80 border-b border-border"
      data-testid="site-nav"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="w-8 h-8 rounded-sm bg-primary text-primary-foreground grid place-items-center">
            <Camera size={16} strokeWidth={2.4} />
          </span>
          <span className="font-display font-bold text-lg tracking-tight">
            Snap<span className="text-primary">.</span>Send<span className="text-primary">.</span>Repair
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a href="#how" className="hover:text-primary transition-colors" data-testid="nav-how">How it works</a>
          <a href="#services" className="hover:text-primary transition-colors" data-testid="nav-services">Services</a>
          <a href="#faq" className="hover:text-primary transition-colors" data-testid="nav-faq">FAQ</a>
        </nav>
        <button
          onClick={() => { track("hero_cta_click", { location: "nav" }); onCtaClick(); }}
          className="btn-lift bg-primary text-primary-foreground rounded-sm px-5 py-2.5 text-sm font-medium"
          data-testid="nav-cta"
        >
          Get a quote
        </button>
      </div>
    </header>
  );
}
